import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "flex flex-col items-center gap-4 justify-center"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]" }, "Loading...")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-center" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputFile = _resolveComponent("InputFile")!
  const _component_mdicon = _resolveComponent("mdicon")!
  const _component_NewModal = _resolveComponent("NewModal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_NewModal, {
      title: "Recepción de contrato",
      visible: _ctx.visible,
      "onUpdate:visible": _cache[0] || (_cache[0] = (e) => _ctx.$emit('update:visible', e))
    }, {
      default: _withCtx(() => [
        (!_ctx.isLoading)
          ? (_openBlock(), _createBlock(_component_InputFile, {
              key: 0,
              onUploadFile: _ctx.uploadFile,
              class: "mt-4"
            }, null, 8, ["onUploadFile"]))
          : _createCommentVNode("", true),
        (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", null, [
                _createVNode(_component_mdicon, {
                  name: "file-document-arrow-right",
                  size: "45"
                })
              ]),
              _hoisted_2
            ]))
          : _createCommentVNode("", true),
        _hoisted_3
      ]),
      footer: _withCtx(() => [
        _hoisted_4
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}